const PageModels = () => import('@/modules/flowable/model/PageModels')

const PageTasks = () => import('@/modules/flowable/myTask/PageTasks')

export default [

  {
    path: '/flowable/models',
    name: 'flowableModel',
    component: PageModels,
    meta: {
      title: '流程定义',
      isBlack: true
    },
  },
  {
    path: '/flowable/myTask',
    name: 'PageTasks',
    component: PageTasks,
    meta: {
      title: '我的待办',
      isBlack: true
    },
  },
  {
    path: '/flowable/myTaskDone',
    name: 'PageTasksDone',
    component: () => import('@/modules/flowable/myTask/PageTasksDone'),
    meta: {
      title: '我的待办',
      isBlack: true
    },

  }
]
